import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const ProspeccionImportarModal = ({ onClose, onImported }) => {
  const [step, setStep]       = useState("upload"); // 'upload' | 'preview'
  const [file, setFile]       = useState(null);
  const [segmento, setSegmento] = useState("");
  const [origen, setOrigen]   = useState("");
  const [preview, setPreview] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [segmentos, setSegmentos] = useState([]);
  const [origenes, setOrigenes] = useState([]);

  useEffect(() => {
    axios.get(`${BASE}/buscar_segmentos.php`)
      .then((r) => { if (Array.isArray(r.data)) setSegmentos(r.data); })
      .catch(() => {});
    axios.get(`${BASE}/buscar_origenes_prospeccion.php`)
      .then((r) => { if (Array.isArray(r.data)) setOrigenes(r.data); })
      .catch(() => {});
  }, []);

  const handlePreview = async (e) => {
    e.preventDefault();
    if (!file)     return toast.error("Cargá un archivo CSV");
    if (!segmento) return toast.error("Seleccioná el segmento");
    if (!origen)   return toast.error("Seleccioná el origen");

    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append("archivo", file);
      fd.append("segmento", segmento);
      fd.append("origen",   origen);
      const r = await axios.post(`${BASE}/prospectos_importar_preview.php`, fd);
      if (r.data?.success) {
        setPreview(r.data);
        setStep("preview");
      } else {
        toast.error(r.data?.mensaje || "Error al procesar archivo");
      }
    } catch {
      toast.error("Error de conexión");
    } finally {
      setSubmitting(false);
    }
  };

  const handleConfirmar = async () => {
    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append("archivo",  file);
      fd.append("segmento", segmento);
      fd.append("origen",   origen);
      const r = await axios.post(`${BASE}/prospectos_importar_confirmar.php`, fd);
      if (r.data?.success) {
        toast.success(`✓ Se importaron ${r.data.importados} prospectos`);
        if (onImported) onImported();
      } else {
        toast.error(r.data?.mensaje || "Error al importar");
        setSubmitting(false);
      }
    } catch {
      toast.error("Error de conexión");
      setSubmitting(false);
    }
  };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={e => e.stopPropagation()}>
        <h2 style={{ margin: "0 0 6px", fontSize: 20, fontWeight: 700, color: "#9f0059" }}>
          ⬆ Importar prospectos desde CSV
        </h2>
        <p style={{ margin: "0 0 18px", color: "#666", fontSize: 13 }}>
          {step === "upload" ? "Subí un archivo CSV con las columnas indicadas en la plantilla." : "Revisá los datos antes de confirmar la importación."}
        </p>

        {step === "upload" && (
          <form onSubmit={handlePreview}>
            <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, padding: "10px 14px", marginBottom: 16, fontSize: 12, color: "#1e40af" }}>
              📄 <a href={`${BASE}/prospectos_plantilla_descargar.php`} target="_blank" rel="noreferrer" style={{ color: "#1e40af", fontWeight: 700 }}>Descargar plantilla CSV</a>
            </div>

            <Row>
              <Field label="Segmento (se aplica a todas las filas) *">
                <select style={inp} value={segmento} onChange={(e) => setSegmento(e.target.value)}>
                  <option value="">Seleccionar…</option>
                  {segmentos.map((s) => <option key={s.id} value={s.nombre}>{s.nombre}</option>)}
                </select>
              </Field>
              <Field label="Origen (se aplica a todas las filas) *">
                <select style={inp} value={origen} onChange={(e) => setOrigen(e.target.value)}>
                  <option value="">Seleccionar…</option>
                  {origenes.map((o) => <option key={o.id} value={o.nombre}>{o.nombre}</option>)}
                </select>
              </Field>
            </Row>

            <Field label="Archivo CSV *">
              <input
                type="file"
                accept=".csv"
                onChange={(e) => setFile(e.target.files?.[0] || null)}
                style={{ ...inp, padding: 8 }}
              />
            </Field>

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 20 }}>
              <button type="button" onClick={onClose} style={btnSecondary} disabled={submitting}>Cancelar</button>
              <button type="submit" style={btnPrimary} disabled={submitting}>
                {submitting ? "Procesando…" : "Continuar →"}
              </button>
            </div>
          </form>
        )}

        {step === "preview" && preview && (
          <div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10, marginBottom: 18 }}>
              <Stat label="Válidas"     value={preview.validas?.length || 0}    color="#166534" />
              <Stat label="Duplicadas"  value={preview.duplicadas?.length || 0} color="#92400e" />
              <Stat label="Con errores" value={preview.errores?.length || 0}    color="#991b1b" />
            </div>

            <div style={{ maxHeight: 300, overflowY: "auto", border: "1px solid #f0e6ec", borderRadius: 8, marginBottom: 16 }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                <thead style={{ background: "#fdf0f6", position: "sticky", top: 0 }}>
                  <tr>
                    <th style={th}>Fila</th>
                    <th style={th}>Empresa</th>
                    <th style={th}>Contacto</th>
                    <th style={th}>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {(preview.filas || []).map((f, i) => (
                    <tr key={i} style={{ borderBottom: "1px solid #f7f4f6", background: f.estado === "error" ? "#fef2f2" : f.estado === "duplicado" ? "#fef3c7" : "#fff" }}>
                      <td style={td}>{f.fila}</td>
                      <td style={td}>{f.empresa || <em style={{ color: "#bbb" }}>(vacío)</em>}</td>
                      <td style={td}>{f.contacto_nombre || "—"}</td>
                      <td style={td}>
                        {f.estado === "valida"    && <span style={{ color: "#166534" }}>✓ válida</span>}
                        {f.estado === "duplicado" && <span style={{ color: "#92400e" }} title={f.detalle}>⚠ duplicado</span>}
                        {f.estado === "error"     && <span style={{ color: "#991b1b" }} title={f.detalle}>❌ {f.detalle}</span>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 18 }}>
              <button type="button" onClick={() => setStep("upload")} style={btnSecondary} disabled={submitting}>
                ← Volver
              </button>
              <button type="button" onClick={handleConfirmar} style={btnPrimary} disabled={submitting}>
                {submitting ? "Importando…" : `Importar ${(preview.validas?.length || 0) + (preview.duplicadas?.length || 0)} filas`}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const overlay = { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 20 };
const modal = { background: "#fff", borderRadius: 14, padding: "26px 30px", maxWidth: 720, width: "100%", maxHeight: "90vh", overflowY: "auto", boxShadow: "0 8px 32px rgba(0,0,0,0.18)" };
const inp = { width: "100%", padding: "9px 12px", border: "1.5px solid #e0d6dc", borderRadius: 8, fontSize: 13, color: "#222", background: "#fafafa", outline: "none", boxSizing: "border-box", fontFamily: "inherit" };
const btnPrimary = { padding: "10px 22px", background: "#9f0059", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer" };
const btnSecondary = { padding: "10px 22px", background: "#fff", color: "#666", border: "1.5px solid #e0d6dc", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer" };
const th = { padding: "8px 12px", fontSize: 11, fontWeight: 700, color: "#9f0059", textTransform: "uppercase", letterSpacing: "0.05em", textAlign: "left", borderBottom: "1.5px solid #f0e6ec" };
const td = { padding: "7px 12px", fontSize: 12, color: "#222" };
const Field = ({ label, children }) => (<div style={{ marginBottom: 12 }}><label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#888", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 4 }}>{label}</label>{children}</div>);
const Row = ({ children }) => (<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>{children}</div>);
const Stat = ({ label, value, color }) => (
  <div style={{ background: color + "15", borderLeft: `3px solid ${color}`, padding: "10px 14px", borderRadius: 4 }}>
    <div style={{ fontSize: 24, fontWeight: 800, color }}>{value}</div>
    <div style={{ fontSize: 11, color: "#888", textTransform: "uppercase", letterSpacing: "0.05em" }}>{label}</div>
  </div>
);

export default ProspeccionImportarModal;
